import React from 'react'
import { iconProps } from '../Helper'

export const OutputLangIcon = ({ className }: iconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <mask id="mask0_6767_66352" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9"/>
        </mask>
        <g mask="url(#mask0_6767_66352)">
            <path className={className} d="M1.5 21.0385V4.30775C1.5 3.80258 1.675 3.375 2.025 3.025C2.375 2.675 2.80258 2.5 3.30775 2.5H18.6923C19.1974 2.5 19.625 2.675 19.975 3.025C20.325 3.375 20.5 3.80258 20.5 4.30775V11.25H19V4.30775C19 4.23075 18.9679 4.16025 18.9038 4.09625C18.8398 4.03208 18.7693 4 18.6923 4H3.30775C3.23075 4 3.16025 4.03208 3.09625 4.09625C3.03208 4.16025 3 4.23075 3 4.30775V17.3848L4.4 16H10.5V17.5H5.0385L1.5 21.0385Z" fill="white"/>
            <path className={className} d="M16.8013 20.4429L18.7448 17.4423H12.5V16L18.7448 15.9429L16.8013 13L23 16.9423L16.8013 20.4429Z" fill="white"/>
        </g>
    </svg>
  )
}
